<template>
  <div
    ref="splashSnippet"
    class="splash-snippet critical-component-clear"
    :class="$blockClass(blockClass, 'splash-snippet')"
  >
    <div class="splash-snippet__media">
      <art-direction
        v-if="mobileImage || desktopImage"
        :image="mobileImage"
        :image-desktop="desktopImage"
        :padding="false"
      />

      <video-player
        v-if="desktopVideo && !isMobile"
        block-class="splash-snippet"
        :src="desktopVideo.src"
        :poster="desktopImage.src"
        :preload="videoPreloadValue()"
        autoplay
        loop
        muted
        ignore-play-pause-events
        @click="handleScroll"
      />

      <video-player
        v-if="mobileVideo && isMobile"
        block-class="splash-snippet"
        :src="mobileVideo.src"
        :poster="mobileImage.src"
        :preload="videoPreloadValue()"
        autoplay
        loop
        muted
        ignore-play-pause-events
        @click="handleScroll"
      />
    </div>

    <div
      v-if="showLogo"
      class="splash-snippet__header"
    >
      <logo />
    </div>

    <div class="splash-snippet__contents l3-10">
      <h4
        v-if="title"
        class="
          splash-snippet__title
          text-heading-3xl
          text-heading-6xl-desktop
        "
        v-text="title"
      />
      <btn
        v-if="ctaUrl"
        class="
          splash-snippet__cta-text
          text-body-s
          text-body-m-desktop
        "
        :url="ctaUrl"
        :label="ctaText"
      />
    </div>

    <div class="splash-snippet__footer">
      <button
        v-if="showArrow"
        type="button"
        class="
          splash-snippet__action
          text-body-s
        "
        :aria-label="$string('splash_snippet.scroll_down')"
        @click="handleScroll"
      >
        <arrow-down />
      </button>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Splash snippet (splash-snippet)
 * -----------------------------------------------------------------------------
 * Video splash snippet with content.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import ArrowDown from '~icons/direction/chevron/down.svg'
import Logo from '~icons/misc/name.svg'
import { mapState } from 'vuex'
import VideoPlayer from '~async/video-player/video-player'
import Btn from '~global/btn/btn'
import ArtDirection from '~global/images/art-direction.vue'
import { debounce, videoPreloadValue } from '~/helpers/general'

export default {
  name: 'SplashSnippet',
  components: {
    ArrowDown,
    Logo,
    VideoPlayer,
    Btn,
    ArtDirection,
  },

  props: {
    desktopImage: {
      type: Object,
      default: () => ({}),
    },

    mobileImage: {
      type: Object,
      default: () => ({}),
    },

    desktopVideo: {
      type: Object,
      default: () => ({}),
    },

    mobileVideo: {
      type: Object,
      default: () => ({}),
    },

    title: {
      type: String,
      default: '',
    },

    ctaUrl: {
      type: String,
      default: '',
    },

    ctaText: {
      type: String,
      default: '',
    },

    showArrow: {
      type: Boolean,
      default: false,
    },

    showLogo: {
      type: Boolean,
      default: false,
    },

    blockClass: {
      type: String,
      default: '',
    },
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),
  },

  mounted() {
    document.documentElement.style.setProperty(
      '--splash-height',
      `${window.innerHeight}px`,
    )

    this.setEventListeners()
  },

  methods: {
    videoPreloadValue,

    setEventListeners() {
      window.visualViewport.addEventListener(
        'resize',
        debounce(() => {
          document.documentElement.style.setProperty(
            '--splash-height',
            `${window.innerHeight}px`,
          )
        }),
      )
    },

    /**
     * Handles scroll event when arrow icon is visible
     */
    handleScroll() {
      window.scroll({
        top: this.$refs.splashSnippet.offsetHeight,
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss">
@import './splash-snippet';
</style>
